import { render } from "./UserProfileGallery.vue?vue&type=template&id=ad7d2c22&ts=true"
import script from "./UserProfileGallery.vue?vue&type=script&lang=ts"
export * from "./UserProfileGallery.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__